import { defineStore } from "pinia";

export const usePrintDialogStore = defineStore("printDialog", {
  persist: true,

  state: () => {
    return {
      fileFormat: "pdf-pdf",
      pageSize: "auto",
      orientation: "portrait",
      zoom: 3.0,
    };
  },

  getters: {
    archiveFormat: (state) => state.fileFormat.split("-")[0],
    innerFormat: (state) => state.fileFormat.split("-")[1],
  },
});
